function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOcri = function SvgOcri(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M20.979 7.076a.8.8 0 0 1-.794.8.8.8 0 0 1-.802-.8A2.48 2.48 0 0 0 16.91 4.6a.8.8 0 0 1-.802-.8.8.8 0 0 1 .802-.8 4.076 4.076 0 0 1 4.07 4.075zM7.076 3a.8.8 0 0 1 .802.8c0 .441-.36.8-.802.8a2.474 2.474 0 0 0-2.473 2.475c0 .441-.36.8-.802.8s-.794-.359-.794-.8A4.07 4.07 0 0 1 7.076 3m-4.07 13.925c0-.442.352-.8.794-.8a.8.8 0 0 1 .802.8A2.473 2.473 0 0 0 7.075 19.4a.8.8 0 0 1 .802.8c0 .441-.36.8-.802.8a4.07 4.07 0 0 1-4.07-4.075zM16.91 21a.8.8 0 0 1-.802-.8.8.8 0 0 1 .802-.8 2.48 2.48 0 0 0 2.473-2.475.8.8 0 0 1 .802-.8.8.8 0 0 1 .794.8A4.077 4.077 0 0 1 16.909 21zm-.819-13.199c.442 0 .802.359.802.8s-.36.8-.802.8H7.886a.8.8 0 0 1 0-1.6zM12.897 11.2c.442 0 .802.359.802.8s-.36.8-.802.8H7.886a.8.8 0 0 1 0-1.6zm1.941 3.399c.442 0 .802.359.802.8a.8.8 0 0 1-.802.8H7.886a.8.8 0 0 1 0-1.6z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOcri);
export default ForwardRef;